class CommonUtils {
    static htmlEncode(str) {
        return str.replace(/[&<>'"]/g,
            tag => ({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                "'": '&#39;',
                '"': '&quot;'
            }[tag]));
    }

    static htmlDecode(str) {
        return str.replace('&amp;', '&')
            .replace('&lt;', '<')
            .replace('&gt;', '>')
            .replace('&#39;', "'")
            .replace('&quot;', '"')
    }


    /**
     * 空值判定
     * @param {*} value 待验证值
     * @returns {Boolean} true:空; false:非空
     */
    static isEmpty(value) {
        if (value === null) return true;
        if (typeof value === 'undefined') return true;
        if (typeof value === 'string' && value === '') return true;
        if (Array.isArray(value) && value.length < 1) return true;
        if (typeof value === 'object' && value.constructor.name === 'Object' && Object.keys(value).length < 1 && Object.getOwnPropertyNames(value) < 1) return true;
        return false
    }

    /**
     * 截取两个字符串之间的字符串
     * @param {String} str 原字符串
     * @param {String} firstStr 起始字符串
     * @param {String} secondStr 截止字符串
     */
    static getCenterStr(str, firstStr, secondStr) {
        if (!str) return "";
        if (str.indexOf(firstStr) < 0) return "";
        let subFirstStr = str.substring(str.indexOf(firstStr) + firstStr.length, str.length);
        let subSecondStr = subFirstStr.substring(0, subFirstStr.indexOf(secondStr));
        return subSecondStr;
    }

    // 判断是否为对象
    static isObject(obj) {
        return Object.prototype.toString.call(obj) === "[object Object]";
    }

    // 获取嵌套对象属性的值
    static getObjValue(data, target, valueTypeName) {
        let keys = Object.keys(data)
        for (const key of keys) {
            if (key === target) {
                return data[key];
            }
            let value = data[key];
            if (typeof value === 'object' || value instanceof Array) {
                const result = this.getObjValue(data[key], target);
                if (result && (!valueTypeName || typeof (result) === valueTypeName)) {
                    return result;
                }
            }
        }
    }

    // 生成一个随机数
    static randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min)
    }

    /**
     *  把对象转换成query的参数
     */
    static convertObj2QueryParams(args) {
        var keys = Object.keys(args);
        keys = keys.sort()
        var newArgs = {};
        keys.forEach((key) => {
            newArgs[key] = args[key];
        });
        var string = '';
        for (var k in newArgs) {
            string += '&' + k + '=' + newArgs[k];
        }
        string = string.substr(1);
        return string;
    }

    static async timeSleep(ms) {
        await new Promise(resolve => {
            setTimeout(() => {
                resolve(true);
            }, ms);
        });
    }


    /**
     * 函数用于比较两个（或更多个）对象的键值，并返回差集
     * @param {object} fixedobj
     * @param {object} obj
     */
    static diffData(fixedobj, obj) {
        let diff = {}
        for (let i of Object.keys(obj)) {
            let t1 = obj[i]
            let t2 = fixedobj[i]
            if (t1 !== t2) diff[i] = t1
        }
        return diff
    }

    //router用新标签页进行跳转页面
    static routerPush_blank(router, obj) {
        const {href} = router.resolve(obj);
        window.open(href, '_blank');
    }

    static setCookie(c_name, value, expire) {
        var date = new Date()
        date.setSeconds(date.getSeconds() + expire)
        document.cookie = c_name + "=" + escape(value) + "; expires=" + date.toGMTString()
        //console.log(document.cookie)
    }

    static getCookie(keyName) {
        if (document.cookie.length > 0) {
            var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split("="); //再次切割
                //判断查找相对应的值
                if (arr2[0] == keyName) {
                    return arr2[1]; //保存到保存数据的地方
                }
            }
        }
    }

    static delCookie(c_name) {
        this.setCookie(c_name, "", -1)
    }

    /**
     * 获取每个页面的seo数据
     * @param vue 页面组件
     * @param pageName 页面名字，对应langv4的key比如home
     * @param data 页面传进来的数据，不同的页面的数据不一样 产品列表是dataAll所有的数据
     */
    static getRichSnippetComplement(vue, pageName, data) {
        let seoHelper = require('./helper/seo_helper');
        return seoHelper.getRichSnippetComplement(vue, pageName, data);
    }

    //动态加载css
    static loadStyle(url) {
        // var link = document.createElement('link');
        // link.type = 'text/css';
        // link.rel = 'stylesheet';
        // link.href = url; //css链接
        // var head = document.getElementsByTagName('head')[0];
        // head.appendChild(link);

        import(url);
    }

    //动态加载字体
    static loadFont(name, url) {
        //name 字体名称
        //url  字体链接
        let style = document.createElement('style');
        style.type = 'text/css';
        style.innerText = '@font-face {font-family:' + name + ';src:url(' + url + ')};font-display: swap';
        document.getElementsByTagName('head')[0].appendChild(style);
    }

    //动态加载js
    static loadJs(url) {
        var link = document.createElement('script');
        link.type = 'text/javascript';
        link.src = url; //js链接
        var head = document.getElementsByTagName('head')[0];
        head.appendChild(link);
    }
}

module.exports = CommonUtils;
